import { css } from '@emotion/react';
import _ from 'lodash';

import { Tag } from '@adflow/frontend/ui-common';
import { theme } from '@adflow/frontend/ui-theme';
import { isNotNullish } from '@adflow/shared/util-js';

import { HistoryEntryFieldLayout } from './HistoryEntryFieldLayout';
import { HistoryIconMinus } from './HistoryIconMinus';
import { HistoryIconPlus } from './HistoryIconPlus';

type ArrayItem = {
	id?: number | string;
	name: string;
} | null;

const styles = {
	area: css({
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		minHeight: '1.5rem',
		columnGap: '0.25rem',
	}),
};

function formatArrayItemsToTags(items: ArrayItem[], added = true) {
	return (
		<>
			{items
				.map((item) => (item?.name ? item : null))
				.filter(isNotNullish)
				.map((item) => (
					<Tag
						key={item?.id ?? item.name}
						text={item.name}
						color={
							added
								? theme.colors.background.tag.blue
								: theme.colors.background.tag.gray
						}
					>
						{item.name}
					</Tag>
				))}
		</>
	);
}

interface HistoryEntryFieldArrayItemsProps {
	oldArrayItems: ArrayItem[];
	newArrayItems: ArrayItem[];
	label: string;
}
export function HistoryEntryFieldArrayItems({
	oldArrayItems,
	newArrayItems,
	label,
}: HistoryEntryFieldArrayItemsProps) {
	const removedArrayItems = _.differenceBy(
		oldArrayItems,
		newArrayItems,
		(t) => t?.id
	).filter(isNotNullish);
	const addedArrayItems = _.differenceBy(
		newArrayItems,
		oldArrayItems,
		(t) => t?.id
	).filter(isNotNullish);

	if (addedArrayItems.length === 0 && removedArrayItems.length === 0) {
		return null;
	}

	return (
		<HistoryEntryFieldLayout label={label}>
			{addedArrayItems.length > 0 ? (
				<div css={styles.area}>
					<HistoryIconPlus /> {formatArrayItemsToTags(addedArrayItems)}
				</div>
			) : null}
			{removedArrayItems.length > 0 ? (
				<div css={styles.area}>
					<HistoryIconMinus />{' '}
					{formatArrayItemsToTags(removedArrayItems, false)}
				</div>
			) : null}
		</HistoryEntryFieldLayout>
	);
}
